import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Yükleniyor...',
  size = 40 
}) => {
  return (
    <div className="loading-spinner-container">
      <div 
        className="loading-spinner" 
        style={{ width: size, height: size }}
      ></div>
      <p className="loading-message">
        {message}
      </p>
    </div>
  );
};

export default LoadingSpinner;